// extracted by mini-css-extract-plugin
export default {"cont__contact":"contactStyle_cont__contact__ojQM4","cont__contact_form":"contactStyle_cont__contact_form__mg6rw"};